import PropTypes from "prop-types";
import React, { Fragment, PureComponent } from "react";
import { PopoverBody } from "reactstrap";

import { PropTypeShapes } from "../../types";
import preprocessorQuery from "../../utils/preprocessorQuery";
import FocusedPopover from "../popover/FocusedPopover";
import SidebarButton from "./SidebarButton";

class SidebarPopoverButton extends PureComponent {
  constructor(props) {
    super(props);
    this.state = {
      popoverOpen: false
    };
    this.togglePopover = this.togglePopover.bind(this);
    this.onPopoverClick = this.onPopoverClick.bind(this);
  }

  togglePopover() {
    this.setState({
      popoverOpen: !this.state.popoverOpen
    });
  }

  onPopoverClick(e) {
    e.stopPropagation();
    this.togglePopover();
  }

  render() {
    const { id, tooltip, icon, color, isPulsate, placement, isActive, children } = this.props;

    return (
      <Fragment>
        <SidebarButton
          id={id}
          key={id}
          pulse={isPulsate}
          icon={icon}
          color={color}
          onClick={this.togglePopover}
          active={isActive}
          tooltip={tooltip}
        />
        {this.state.popoverOpen ? (
          <FocusedPopover
            className={`toolbarPopover ${preprocessorQuery.isTablet() ? "tablet" : ""}`}
            placement={placement ? placement : "right"}
            hideArrow={false}
            isOpen={this.state.popoverOpen}
            target={id}
            toggle={this.togglePopover}
            trigger="legacy"
            boundariesElement="window"
          >
            <PopoverBody onClick={this.onPopoverClick}>
              <div className="sidebarPopoverItemsGroup">{children}</div>
            </PopoverBody>
          </FocusedPopover>
        ) : null}
      </Fragment>
    );
  }
}

SidebarPopoverButton.propTypes = {
  onClick: PropTypes.func,
  icon: PropTypes.string.isRequired,
  color: PropTypes.string,
  isActive: PropTypes.bool,
  isPulsate: PropTypes.bool,
  children: PropTypeShapes.elementOrArray,
  id: PropTypes.string.isRequired,
  tooltip: PropTypes.string,
  placement: PropTypes.string
};

export default SidebarPopoverButton;
